// 2026-09-30：手机网页使用小程序式导航分组及页面布局，业务权限仍由原菜单判断。
export const isMobileViewport = (): boolean => window.matchMedia('(max-width: 768px)').matches

export interface MobileMenu { title: string; path: string; flag?: string; enabled: boolean }
export interface MobileTab { title: string; icon: string; menus: MobileMenu[] }
const catalogPaths = ['/main/bokes', '/main/cloths', '/main/retails', '/main/fabrics', '/main/accessories', '/main/decorations']
const detailPaths = ['/main/bokesdetail', '/main/clothdetail', '/main/retailDetails', '/main/fabricdetails', '/main/decorationDetails', '/main/retailCloth', '/main/clothsell']
const formPaths = ['/main/bokemakingorder', '/main/clothmakingorder', '/main/makingboke', '/main/autoscale']
export function mobilePageClass(path: string): string {
  if (path === '/main/index') return 'mobile-home'
  if (catalogPaths.includes(path)) return 'mobile-catalog'
  if (detailPaths.includes(path)) return 'mobile-product-detail'
  if (formPaths.includes(path)) return 'mobile-order-form'
  if (path.toLowerCase().includes('orderconfirm')) return 'mobile-checkout'
  if (path === '/main/buycar') return 'mobile-cart'
  if (path.startsWith('/main/cuscenter')) return 'mobile-customer-center'
  return 'mobile-service-page'
}
export const showMobileTabs = (path: string): boolean =>
  path === '/main/index' || catalogPaths.includes(path) || ['/main/cuscenter', '/main/cuscenter/info'].includes(path)

export function mobileProductTabs(menus: MobileMenu[]): MobileTab[] {
  const visible = menus.filter(menu => menu.enabled)
  const groups = [
    { title: '首页', icon: 'home1', paths: ['/main/index'] },
    { title: '版型库', icon: 'cloth', paths: ['/main/bokes'] },
    { title: '成衣/定制', icon: 'cloth', paths: ['/main/cloths', '/main/retails'] },
    { title: '面辅料', icon: 'package', paths: ['/main/fabrics', '/main/accessories', '/main/decorations'] }
  ]
  return groups.map(group => {
    const items = visible.filter(menu => group.paths.includes(menu.path))
    return { title: items.length === 1 ? items[0].title : group.title, icon: group.icon, menus: items }
  }).filter(group => group.menus.length > 0)
}
